import React, { Component } from 'react';

class TeacherSettings extends Component {
  render() {
    return <div className="TeacherSettings">{this.props.children}</div>;
  }
}

export default TeacherSettings;



// WEBPACK FOOTER //
// ./src/pages/teacher/Settings/index.js